import { REGISTER_COLUMNS } from "../../utils/states";
import jsPDF from "jspdf";
import "jspdf-autotable";

// Km de la próxima mantención efectiva:
// - si el servicio fue reseteado y tiene nextService guardado, ese valor;
// - si no, el intervalo (la mantención cae al llegar al intervalo).
function effectiveNextKm(service) {
  const intervalNum = Number(service.intervalNum) || 0;
  const nextNum =
    Number(
      String(service.nextServiceNum || service.nextService || "0")
        .split(".")
        .join("")
    ) || 0;
  return service.reset && nextNum > 0 ? nextNum : intervalNum;
}

function getServiceStatus(service, kms) {
  const nKms = Number(kms) || 0;
  const intervalNum = Number(service.intervalNum) || 0;
  const nextServiceNum = Number(
    String(service.nextServiceNum || service.nextService || "0").split(".").join("")
  );

  const isInspection = intervalNum === 0 && nextServiceNum === 0;

  if (isInspection) {
    return service.reset ? "AL DIA" : "ATRASADA";
  }

  const effective = effectiveNextKm(service);
  if (effective > 0 && nKms < effective) {
    return effective - nKms <= 1000 ? "PROXIMO" : "AL DIA";
  }
  if (effective > 0 && nKms >= effective) {
    return "ATRASADA";
  }

  return service.reset ? "AL DIA" : "ATRASADA";
}

function formatKm(n) {
  return Number(n).toLocaleString("es-CL");
}

function buildPdfData(data, kms) {
  return data.map((service) => {
    const title = service.title || "";
    // Próx. Mant.: nextService guardado si fue reseteado; si está vacío, el intervalo.
    const effective = effectiveNextKm(service);
    const nextService = effective > 0 ? formatKm(effective) : "-";
    // Descripción / Productos: siempre visible — la usan los mecánicos para
    // saber qué productos buscar antes de ejecutar el servicio.
    const description = service.description || "-";
    const date = service.reset ? (service.date || "-") : "-";
    const worker =
      service.reset && service.worker && service.worker !== "-"
        ? service.worker
        : "-";
    const status = getServiceStatus(service, kms);
    return [title, description, date, worker, nextService, status];
  });
}

function addPdfHeader(doc) {
  doc.setTextColor(0, 102, 204);
  doc.setFontSize(12);
  doc.text("PAUTA DE MANTENCION", 14, 8);
  doc.setFontSize(10);
}

function addPdfFooter(doc) {
  doc.setTextColor(155, 153, 153);
  doc.setFontSize(10);
  doc.text(
    "Kurt Moller 985, Linares - 73 2 227032",
    5,
    doc.internal.pageSize.height - 10
  );
  doc.text(
    "La pauta se basa en promedios de mantencion. Revisar el manual de su vehiculo ante cualquier duda",
    5,
    doc.internal.pageSize.height - 5
  );
  const logoEl = document.querySelector("#logo-pdf");
  if (logoEl) {
    doc.addImage(logoEl, "PNG", 190, doc.internal.pageSize.height - 25, 20, 20);
  }
}

function addServiceTable(doc, cleanPdfData) {
  const cols = [
    "Servicio",
    "Descripción / Productos",
    "Fecha",
    "Mecánico",
    "Próx. Mant.",
    "Estado",
  ];
  const statusIdx = 5;
  doc.autoTable({
    head: [cols],
    body: cleanPdfData,
    theme: "grid",
    styles: { fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    headStyles: { fontSize: 8, fillColor: [102, 187, 154] },
    columnStyles: {
      0: { cellWidth: 38 },
      1: { cellWidth: 65 },
      2: { cellWidth: 22 },
      3: { cellWidth: 28 },
      4: { cellWidth: 22 },
      5: { cellWidth: 22 },
    },
    didParseCell: (hookData) => {
      const status = hookData.row.raw[statusIdx];
      if (status === "ATRASADA") {
        hookData.cell.styles.fontStyle = "bold";
        if (hookData.column.index === statusIdx) {
          hookData.cell.styles.textColor = [204, 0, 0];
        }
      } else if (status === "PROXIMO" && hookData.column.index === statusIdx) {
        hookData.cell.styles.textColor = [204, 102, 0];
      } else if (status === "AL DIA" && hookData.column.index === statusIdx) {
        hookData.cell.styles.textColor = [0, 102, 0];
      }
    },
  });
}

export function exportPdf(columns, data, kms, file) {
  const doc = new jsPDF("p", "mm", [216, 279]);
  const fileTitles = REGISTER_COLUMNS.map((v) => v.title);
  const fileData = [[...Object.values(file), file.date]];
  const cleanPdfData = buildPdfData(data, kms);

  if (window.location.pathname === "/dashboard/newfile") {
    addPdfHeader(doc);
    addPdfFooter(doc);
    doc.autoTable({ head: [fileTitles], body: fileData });
  }

  addServiceTable(doc, cleanPdfData);

  if (window.location.pathname === "/dashboard/newfile") {
    doc.save(`${file.license}.pdf`);
    return;
  }
  doc.save(`data.pdf`);
}

export function publicPdf(columns, data, kms, file) {
  const doc = new jsPDF("p", "mm", [216, 279]);
  const fileTitles = REGISTER_COLUMNS.map((v) => v.title);
  const fileData = [[...Object.values(file), file.date]];
  const cleanPdfData = buildPdfData(data, kms);

  addPdfHeader(doc);
  addPdfFooter(doc);
  doc.autoTable({ head: [fileTitles], body: fileData });
  addServiceTable(doc, cleanPdfData);

  doc.save(`${file.license}.pdf`);
}

export function openPdf(columns, data, kms, file) {
  const doc = new jsPDF("p", "mm", [216, 279]);
  const fileTitles = REGISTER_COLUMNS.map((v) => v.title);
  const fileData = [[...Object.values(file), file.date]];
  const cleanPdfData = buildPdfData(data, kms);

  addPdfHeader(doc);
  addPdfFooter(doc);
  doc.autoTable({ head: [fileTitles], body: fileData });
  addServiceTable(doc, cleanPdfData);

  const pdfBlob = doc.output("blob");
  const url = URL.createObjectURL(pdfBlob);
  return url;
}
